import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box, Form, Input, Button, Textarea, Table, Small, Text, Flex, FlexItem, Grid, GridItem, H3, H2, Checkbox } from "@bigcommerce/big-design";

const Reviews = (props) => {
  // State setters
  const [sku, setSku] = useState('');
  const [filteredReviews, setFilterReviews] = useState({ reviews: [], summary: { starsAverage: 0, numberOfReviews: { total: 0 } } });
  const [allowWriteFilters, setAllowWriteFilters] = useState(false);
  const [loading, setLoading] = useState(false);
  const [testing, setTesting] = useState(false);
  const [allowURLs, setAllowURLs] = useState(false);
  const [reviewFilter, setReviewFilter] = useState({
    words: '',
    ids: '',
    phrases: '',
    urls: allowURLs,
  });

  // Funtionality
  const getFilters = async(url) => {
    try {
      let { data } = await axios.get(url);
      return data;
    } catch(error) {
      console.log(error);
      return {}
    };
  }
  
  const testFilter = async({ words, phrases, ids, urls }, sku) => {
    let url = `/api/reviews/${sku}`;
    var filterConfig = {
      "words": [...words],
      "ids": [...ids],
      "phrases": [...phrases],
      "urls": urls,
    };
  
    try {
      let { data } = await axios.put(url, filterConfig);
      return data;
    } catch(error) {
      console.log(error);
      return []
    }
  }
  
  const writeFilter = async({ words, phrases, ids, urls }, sku) => {
    console.log('Write Filter');

    let url = '/api/reviews/trustpilot-filters';
    var filterConfig = {
      "words": [...words],
      "ids": [...ids],
      "phrases": [...phrases],
      "urls": urls,
    };
    console.log(filterConfig);
    
    try {
      let { data } = await axios.put(url, filterConfig);
      return data;
    } catch(error) {
      console.log(error);
      return []
    }
  }

  const getPayload = () => {
    let filterPhrases = reviewFilter.phrases.split(',').map(phrase => phrase.trim().toLowerCase().replace(/[^a-zA-Z] /g, "")).filter(result => result.length > 0)
    let filterWords = reviewFilter.words.split(',').map(word => word.trim().toLowerCase().replace(/[^a-zA-Z] /g, "")).filter(result => result.length > 0);
    let filterIds = reviewFilter.ids.split(',').map(id => id.trim().toLowerCase().replace(/[^a-zA-Z] /g, "")).filter(result => result.length > 0);
    return { phrases: [...filterPhrases], words: [...filterWords], ids: [...filterIds], urls: allowURLs };
  }

  const handleUpdatereviewFilter = async (e) => {
    e.preventDefault();
    setTesting(true)
    console.log('updating filter...')
    let payload = getPayload();
    let data = await testFilter(payload, sku);
    let { reviews, summary } = data;
    console.log('OK', reviews, summary)
    setFilterReviews({ reviews, summary });
  }

  const handleOnChange = (e) => {
    e.preventDefault();
    setReviewFilter({ ...reviewFilter, [e.currentTarget.name]: e.target.value });
  }

  const handleChangeSKU = (e) => {
    e.preventDefault();
    setSku(e.target.value);
  }

  const toggleAllowWriteFilters = (e) => {
    e.preventDefault();
    setAllowWriteFilters(!allowWriteFilters);
  }

  const writeToStore = async (e) => {
    e.preventDefault();
    console.log('writing to store ....');
    setLoading(true);
    let payload = getPayload();
    let result = await writeFilter(payload);
    setLoading(false);
    console.log('uploaded to webdav', result);
  }

  // Effects
  useEffect(() => {
    if (!testing) {
      getFilters('https://mountainroseherbs.com/content/json/trustpilot-filters.json')
        .then(response => {
          // console.log(response);
          let { words, ids, phrases, urls } = response;
          setReviewFilter({
            words: words.join(','),
            ids: ids.join(','),
            phrases: phrases.join(','),
            urls: urls,
          });
          setAllowURLs(urls)
        });
    }
    setTesting(false);
    // load reviewFilters from JSON file
  }, []);

  return <Box padding="medium">
    <H2>Reviews</H2>
    <Grid gridTemplate={`"sidebar content" / 30% auto`} gridGap={`2rem`}>
      <GridItem gridArea="sidebar">
        <Form fullWidth={true}>
          <Box>
            <Input
              label="SKU"
              required
              name="sku"
              description="Enter SKU to test filters against Trustpilot reviews"
              placeholder="11-00216"
              value={sku}
              onChange={handleChangeSKU}
            />
          </Box>

          <Box marginTop="large">
            <Textarea
              label="Trustpilot Review IDs"
              name="ids"
              description="Use comma-separated values of the Trustpilot ID(s) to explicitly filter out the review"
              placeholder="61f833790784fb0001fe3f49, 61fab41a1a6f9a000175ca5f"
              type="text"
              value={reviewFilter.ids}
              rows={3}
              onChange={handleOnChange}
            />
          </Box>

          <Box marginTop="large">
            <Textarea
              label="Words"
              name="words"
              description="Use comma-separated values of word(s) to filter out the review"
              placeholder="dog, fart"
              type="textarea"
              value={reviewFilter.words}
              onChange={handleOnChange}
              rows={4}
            />
          </Box>

          <Box marginTop="large">
            <Textarea
              label="Phrases"
              name="phrases"
              description="Use comma-separated values of phrase(s) to filter out the review"
              placeholder="senior dog, soups and salads"
              type="textarea"
              value={reviewFilter.phrases}
              onChange={handleOnChange}
              rows={4}
            />
          </Box>

          <Box marginTop="large">
            <Checkbox label={"Filter links"} 
              description={{
                text: 'Checking this box will filter out reviews that include hyperlinks'
              }}
              onChange={() => setAllowURLs(!allowURLs)}
              onClick={() => setAllowURLs(!allowURLs)}
              checked={allowURLs} />
            <hr></hr>
            <Checkbox 
              label={"Enable Write to Store"}
              description={{
                text: 'Checking this box will allow you to upload these filters to Webdav'
              }}
              onChange={toggleAllowWriteFilters}
              onClick={toggleAllowWriteFilters} 
              checked={allowWriteFilters} />
          </Box>

          <Flex 
            alignContent="stretch"
            alignItems="stretch"
            flexDirection="row"
            justifyContent="flex-start"
            flexWrap="nowrap">
            <FlexItem>
              <Button marginTop="medium" marginRight="large"
                onClick={handleUpdatereviewFilter}
                disabled={sku === ''}>{sku !== '' ? "Test Filter(s)" : "Enter a sku to test filters"}</Button>
            </FlexItem>
            <FlexItem>
              <Button marginTop="medium" 
              onClick={writeToStore} 
              disabled={loading || !allowWriteFilters}>{loading ? "writing..." : "Write To Store"}</Button>
            </FlexItem>
          </Flex>
        </Form>
      </GridItem>
      <GridItem gridArea="content">
        <H3>Filtered</H3>
        <Table
          marginLeft="medium"
          columns={[
            { header: 'Id', hash: 'id', tooltip: 'Header tooltip', render: ({ id }) => id },
            { header: 'Stars', hash: 'stars', render: ({ stars }) => stars },
            { header: 'Content', hash: 'content', render: ({ content }) => content },
            // { header: 'CreatedAt', hash: 'createdAt', render: ({ createdAt }) => createdAt },
            // { header: 'Consumer Name', hash: 'consumer', render: ({ consumer }) => consumer.name },
            // { header: 'Consumer Id', hash: 'consumer', render: ({ consumer }) => consumer.id },
          ]}
          items={filteredReviews?.reviews?.productReviews || []}
        />
        <Small marginTop="xSmall">reviews will be filtered by the options provided</Small>
        <Text>average rating: {filteredReviews?.summary?.starsAverage} stars</Text>
        <Text>total number of reviews: {filteredReviews.summary?.numberOfReviews?.total}</Text>
      </GridItem>
    </Grid>
  </Box>
}

export default Reviews